import { KontodelarForKodplan_db_EKKontodel_All } from '../../../Features/Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Queries/EkonomiskAnalysKontodelarQuery/_QueryTypes/KontodelarForKodplan';
import Logger from '../../../Utils/Logger';

/**
 * Kollar om inskickad koddel är aktiv för det inskickade datumet
 */
const koddelIsActiveForDate = (
  koddel: KontodelarForKodplan_db_EKKontodel_All,
  date: string
): boolean => {
  if (
    koddel.FRAN_DATUM == null ||
    koddel.TILL_DATUM == null ||
    typeof koddel.FRAN_DATUM !== 'string' ||
    typeof koddel.TILL_DATUM !== 'string'
  ) {
    Logger.error(
      Error(
        `Koddel ${koddel.BENAMNING} har inget till- eller från-datum eller datum av icke-strängar`
      )
    );
    return false;
  }

  // Om datumet ligger mellan från- och till-datum
  return koddel.FRAN_DATUM <= date && koddel.TILL_DATUM >= date;
};

/**
 * Filtrerar en lista med koddelar till bara aktiva och giltiga för angivet datum
 */
export const getActiveKoddelar = (
  koddelar: KontodelarForKodplan_db_EKKontodel_All[],
  date: string
): KontodelarForKodplan_db_EKKontodel_All[] => {
  return koddelar.filter(
    koddel => koddel.AKTIV && koddelIsActiveForDate(koddel, date)
  );
};
